import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Container from "react-bootstrap/Container"
import Alert from 'react-bootstrap/Alert'
import Meta from "../components/Meta"
import publishStyles from '../styles/Publish.module.css'
import { useAuth } from "../contexts/Auth"
import RegisterModal from "../components/User/RegisterModal"
import Link from "next/link"
import { supabase } from "../utils/supabaseClient"
import { useState } from "react";
import { useRouter } from 'next/router'


export default function Publish(){
   const [ registerModal, setRegisterModal ] = useState(false)
   const router = useRouter()
   const { user, signInGoogle, signOut, signIn } = useAuth()

   const handleRegisterModal = () => {
        setRegisterModal(true)
    }

  const startWriting = async () => {
        const {data:profile, error2} = await supabase
          .from('main_profile')
          .select('id')
          .eq('user',user.id)

        const date = new Date()

        const {data:article, error} = await supabase 
          .from('main_article')
          .insert([
            {profile: profile[0].id, article_published: date}
          ])

        router.push('/draft/' + article[0].id)
  }

    return(
        <>
          <Meta 
            title='Publish an Article on Ordinary Coders' 
            description="WANT TO WRITE? Write an article on any coding-related subject."

          />
             <RegisterModal 
                    show={registerModal} 
                    signInGoogle={signInGoogle} 
                    signIn={signIn}
                    setShow={setRegisterModal}
                    
                />
            <Container className="py-5 px-15">
              <p className="text-muted text-uppercase">WANT TO WRITE?</p>  
              <h1 className="page-title">Submit an article</h1>
              <p className="page-subtext">
                Write an article on any coding-related subject. 
                When you&apos;re done, submit for approval and we&apos;ll notify you via email if your 
                article has been published.
              </p>
              <Row>
                <Col className="mb-5">
                  
                  <div className="text-muted">
                    {/* What we look for, Requirements, Recommendations, and What we're really looking for */}
                    <h4 className="text-dark text-uppercase my-3">Requirements</h4>
                      <ol>
                        <li>Original content</li>
                        <li>Between 250-3000 words</li>
                        <li>Written in fluent English</li>
                        <li>Coding-related subject</li>
                        <li>Not published or submitted elsewhere</li>
                      </ol>

                    <h4 className="text-dark text-uppercase my-3">Recommendations</h4>
                    <ul>
                      <li><u>Content</u>: Is the content informative? Is the writing easy to follow and free of most errors? Are definitions and explanations given to provide clarity to readers?</li>
                      <li><u>Organization</u>: Are comprehensive headings and subheadings used to briefly describe the content in each section? Do the headings provide an organized guide to readers?</li>
                      <li><u>Code</u>: Are relevant code samples provided when needed? Are the samples complete and free of bugs? Can the reader easily identify where the code should be placed in their respective file/ file tree?</li>
                      <li><u>Images</u>: Are the images used directly related to the topic discussed? Do they help improve comprehension?</li>
                    </ul>

                    {/* <h4 className="text-dark text-uppercase my-3">Get paid for your work</h4>
                    <p className="ms-3">
                      The Ordinary Coders Team rewards talented writers who produce strong and comprehensive articles for fellow users.
                      Each month, our team selects users to become regular, paid article writers.
                      <br/><br/>
                      As a compensation for their work, selected writers get paid between $50-$200 USD per article.
                      <br /> <br />
                      Publish two articles on the site and if our team likes your content, we&apos;ll reach out directly via email to discuss the terms and conditions of paid article creation.
                      <br /><br />
                      <b>Note:</b> Article submission and publication on the site does not guarantee fiscal compensation.
                    </p>
                    */}
                   
                  </div>
                  {user ? 
                      <Button className="ms-3" onClick={startWriting} variant="purple">
                          Start Writing
                      </Button>
                    : 
                      <Button className="ms-3" onClick={handleRegisterModal} variant="purple">
                          Start Writing
                      </Button>
                  
                  }
                </Col>
                <Col className="me-auto">
                  {/* <Alert className={publishStyles.alert}>
                    <h6>Interested in getting paid to write?</h6>
                    <p>We offer anywhere between <span className="h6">$50-$200 USD</span> for high quality articles.</p>
                    <em>Get two articles published on the site and we&apos;ll reach out to you directly.</em>
                  </Alert> */}
                </Col>
                </Row>
                <p className="py-5 text-center">
                  <em>
                  Articles not getting approved for publication? Reach out to 
                  <Link href="mailto:info@ordinarymedia.com" passHref>
                    <a className={publishStyles.link}> info@ordinarymedia.com </a>
                  </Link>
                  and we&apos;ll provide direct feedback.
                  </em>
                </p>
            </Container>
        </>
    )
}